const avatarColors = ['blue', 'cyan', 'grape', 'indigo', 'lime', 'orange', 'teal', 'violet', 'yellow'];
export function getAvatarColorFromName(name: string | undefined) {
    return avatarColors[((name && name.charCodeAt(0)) || 420) % avatarColors.length];  
}